import { create } from 'zustand';
import type { ITEToken } from '@timeedit/types';

interface CommonStore {
  user?: ITEToken;
  setUser: (user: ITEToken) => void;
}

export const useCommonStore = create<CommonStore>((set) => ({
  setUser: (state: ITEToken) => set({ user: state }),
}));
